import { styled } from 'styled-components';
import { Utils, device } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

export const LogoWrapperStyled = styled.div`
  ${flexFn()};
  margin-bottom: ${pxToRem(40)};
`;

export const DropdownWrapperStyled = styled.div`
  margin-bottom: ${pxToRem(20)};
`;

export const DescriptionWrapperStyled = styled.div`
  margin-bottom: ${pxToRem(40)};
  width: 100%;

  pre {
    white-space: pre-wrap;
  }

  ul,
  ol {
    padding-left: ${pxToRem(20)};
  }

  > ul,
  > ol {
    margin-bottom: ${pxToRem(20)};
  }
`;

export const StaticComponentsStyled = styled.div`
  width: 100%;
  padding: ${pxToRem([0, 12])};
  margin-bottom: ${pxToRem(40)};
  @media ${device.sm} {
    padding: ${pxToRem([0, 20])};
  }
`;

export const FormHeaderImageStyled = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: ${pxToRem(80)};
`;
